import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import FinancialStats from './FinancialStats';
import StudentStats from './StudentStats';
import ExamStats from './ExamStats';
import ActivityStats from './ActivityStats';
import ReferrerBonus from './ReferrerBonus';
import { authService, ROLE_LEVELS } from '../../services/authService';

const Statistics = () => {
  const [canAccessFinance, setCanAccessFinance] = useState(false);
  const [canAccessManager, setCanAccessManager] = useState(false);

  useEffect(() => {
    const checkPermissions = async () => {
      try {
        const financeAccess = await authService.canAccess(ROLE_LEVELS.FINANCE);
        const managerAccess = await authService.canAccess(ROLE_LEVELS.MANAGER);
        setCanAccessFinance(financeAccess);
        setCanAccessManager(managerAccess);
      } catch (error) {
        console.error('Statistics - Permission check error:', error);
      }
    };
    checkPermissions();
  }, []);
  
  const items = [
    {
      key: 'financial',
      label: '财务统计',
      children: <FinancialStats />
    },
    {
      key: 'referrerBonus',
      label: '推荐人提成',
      children: <ReferrerBonus />,
      // Only show referrer bonus tab for manager role and above
      disabled: !canAccessManager
    },
    {
      key: 'student',
      label: '学员统计',
      children: <StudentStats />
    },
    {
      key: 'exam',
      label: '考试统计',
      children: <ExamStats />
    },
    {
      key: 'activity',
      label: '操作记录',
      children: <ActivityStats />
    }
  ];

  return (
    <div>
      <Tabs 
        defaultActiveKey="financial" 
        items={items}
        type="card"
      />
    </div>
  );
};

export default Statistics; 